import React from 'react';

import Icon from '../../../../../elements/icons/Icon';
import Link from '../../../../../elements/Link';
import styles from '../EventIcons.module.scss';
import { useEventSettings } from '../../../../../../data/hooks/events/useEventSettings';

const QRCode = (props) => {
    const { event, i18n } = props,
        settings = useEventSettings(event.id);

    if (!event.qr_code) return null;

    return (
        <Link className={styles.icon} href="./qr_code">
            <Icon src="img/qr_code_icon.png" color={event.settings.secondary_color} />
            <div>{settings.qr_code_label || i18n['label.qr_code']}</div>
        </Link>
    );
};

export default QRCode;
